import { HIDE_HEADER } from './types'

export function hideHeader(payload) {
  return {
    type: HIDE_HEADER,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/actions/header/header-action.js